export const BOT_PATTERN =
  'googlebot|bingbot|qwantify|duckduckbot|slurp|headlesschrome|headless chrome';
